import { getLocal, LOCAL_STORAGE_KEYS } from "../data/localStorageHelpers";
var useGroupData = function (eventNumber) {
    var groupData = getLocal("".concat(LOCAL_STORAGE_KEYS.GROUP_ID, "-").concat(eventNumber));
    var groupName;
    var groupId;
    if (groupData) {
        var parsedData = JSON.parse(groupData);
        groupName = parsedData.name;
        groupId = parsedData.groupId;
    }
    return {
        groupName: groupName,
        groupId: groupId,
        groupDataIsLoaded: eventNumber !== 0,
    };
};
export default useGroupData;
